import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { OrderType } from 'contracts/OrderTypes';

const { Types, Creators } = createActions(
  {
    request: ['id', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'FETCH_ORDER_TYPE_',
  }
);

export interface FetchOrderTypeState {
  data: OrderType | null;
  loading: boolean;
  errorMessage: string | null;
}

export interface FetchOrderTypeRequestAction {
  id: number;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: OrderType;
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: FetchOrderTypeState = {
  data: null,
  loading: false,
  errorMessage: null,
};

const request = (state: FetchOrderTypeState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: FetchOrderTypeState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: FetchOrderTypeState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: FetchOrderTypeState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const fetchOrderType = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const FetchOrderTypeTypes = Types;
export const FetchOrderTypeActions = Creators;
